import Vue from 'vue';
// used for component<->component & component<->core communication
const EventBus = new Vue();
export default EventBus;